export const GRID = 15;
export const CELL = 40;

// Home cells per color (row, col pairs)
export const HOME_CELLS = {
  RED: [
    [0,0],[0,1],[1,0],[1,1]
  ],
  GREEN: [
    [0,13],[0,14],[1,13],[1,14]
  ],
  YELLOW: [
    [13,0],[14,0],[13,1],[14,1]
  ],
  BLUE: [
    [13,13],[13,14],[14,13],[14,14]
  ]
};

// Main path for each color
export const PATHS = {
  RED: [
    [6,1],[6,2],[6,3],[6,4],[6,5],
    [5,6],[4,6],[3,6],[2,6],[1,6],
    [0,6],[0,7],[0,8],
    [1,8],[2,8],[3,8],[4,8],[5,8],
    [6,9],[6,10],[6,11],[6,12],[6,13],
    [7,14],[8,14],
    [8,13],[8,12],[8,11],[8,10],[8,9],
    [9,8],[10,8],[11,8],[12,8],[13,8],
    [14,8],[14,7],[14,6],
    [13,6],[12,6],[11,6],[10,6],[9,6],
    [8,5],[8,4],[8,3],[8,2],[8,1],
    [7,1],[7,2],[7,3],[7,4],[7,5],[7,6]
  ],
  GREEN: [
    [1,8],[2,8],[3,8],[4,8],[5,8],
    [6,9],[6,10],[6,11],[6,12],[6,13],
    [6,14],[7,14],[8,14],
    [8,13],[8,12],[8,11],[8,10],[8,9],
    [9,8],[10,8],[11,8],[12,8],[13,8],
    [14,8],[14,7],[14,6],
    [13,6],[12,6],[11,6],[10,6],[9,6],
    [8,5],[8,4],[8,3],[8,2],[8,1],
    [8,0],[7,0],[6,0],
    [6,1],[6,2],[6,3],[6,4],[6,5],
    [7,7],[7,8],[7,9],[7,10],[7,11],[7,12]
  ],
  YELLOW: [
    [8,13],[8,12],[8,11],[8,10],[8,9],
    [9,8],[10,8],[11,8],[12,8],[13,8],
    [14,8],[14,7],[14,6],
    [13,6],[12,6],[11,6],[10,6],[9,6],
    [8,5],[8,4],[8,3],[8,2],[8,1],
    [8,0],[7,0],[6,0],
    [6,1],[6,2],[6,3],[6,4],[6,5],
    [5,6],[4,6],[3,6],[2,6],[1,6],
    [0,6],[0,7],[0,8],
    [7,7],[8,7],[9,7],[10,7],[11,7],[12,7]
  ],
  BLUE: [
    [13,6],[12,6],[11,6],[10,6],[9,6],
    [8,5],[8,4],[8,3],[8,2],[8,1],
    [8,0],[7,0],[6,0],
    [6,1],[6,2],[6,3],[6,4],[6,5],
    [5,6],[4,6],[3,6],[2,6],[1,6],
    [0,6],[0,7],[0,8],
    [1,8],[2,8],[3,8],[4,8],[5,8],
    [6,9],[6,10],[6,11],[6,12],[6,13],
    [6,14],[7,14],[8,14],
    [7,7],[6,7],[5,7],[4,7],[3,7],[2,7]
  ],
};

// Safe cells as arrays for easy rendering
export const SAFE_CELLS = [
  [6,1],[1,6],[8,13],[13,8],
  [6,13],[13,6],[8,1],[1,8],
  [6,6],[8,8] // center stars if needed
];

export const TOKENS_PER_PLAYER = 4;
